import React from "react"
import * as styles from "./article-content-media.module.scss"
import Img from "gatsby-image"

const ArticleContentMedia = ({
  heading,
  image,
  alternativemediaImage,
}: {
  heading?: String
  image: any
  alternativemediaImage: any
}) => {
  return (
    <div className={styles.imageContainer}>
      {heading && <h3 className={styles.contentHeading}>{heading}</h3>}
      <div className={styles.image}>
        <Img fluid={image?.fluid} alt={image?.title} />
        <Img
          className={styles.alternativeImage}
          fluid={alternativemediaImage?.fluid}
          alt={alternativemediaImage?.title}
        />
      </div>
    </div>
  )
}

export default ArticleContentMedia
